import { AnyHash, FieldConfig, FieldDataTypes, ModelInterface, Uuid } from '@hidat/huijs-common';
import { HasTenantResource, NestUpdateTrackingResource, ResourceConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';

export const ListenerProfileConfig: ResourceConfig = new ResourceConfig(
  'ListenerProfile',
  'listener_profiles',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.tenantId,
    splixerFieldConfigs.stationId,
    new FieldConfig('listenerId', FieldDataTypes.UID),
    new FieldConfig('settings', FieldDataTypes.HASH),
  ]);

export const ListenerProfileIncludes = {
  listener: 'listener'
}

/**
 * Listener Profile - Defines a listener's connection and settings for a specific station.
 */
export interface ListenerProfileInterface extends ModelInterface, NestUpdateTrackingResource, HasTenantResource {
  listenerId: Uuid | undefined;
  stationId: number | undefined;
  settings: AnyHash | undefined;
}

/**
 * Hybrid listener + profile used to serialize to the player
 */
export interface PlayerProfileInterface {
  id: Uuid | undefined;
  listenerId: Uuid | undefined;
  settings: AnyHash | undefined;
  name: string | undefined;
  email: string | undefined;
  imageUrl: string | undefined;
  createdAt: unknown | undefined;
}
